export class FaceList {
  constructor() {
    this.faces = [];
  }

  push(face) {
    this.faces.push(face);
  }

  get(i) {
    return this.faces[i];
  }

  getAll() {
    return this.faces;
  }
}
